import { InboxOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Upload } from 'antd';
import { useTranslation } from 'react-i18next';

const { Dragger } = Upload;

interface DragAndDropProps {
  onFilesAdded: (files: File[]) => void;
}

const DragAndDrop = (props: DragAndDropProps) => {
  const { onFilesAdded } = props;
  const { t } = useTranslation();
  const handleBeforeUpload = (file: File) => {
    onFilesAdded([file]);

    return false;
  };

  const uploadProps: UploadProps = {
    name: 'file',
    multiple: true,
    beforeUpload: handleBeforeUpload,
    fileList: [], // evita que Ant Design maneje el listado
    showUploadList: false, // opcional: evita mostrar lista de AntD
  };

  return (
    <Dragger {...uploadProps}>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">{t('Hace clic o arrastra archivos a esta área para subir')}</p>
      <p className="ant-upload-hint">{t('podés cargar uno o más archivos')}</p>
    </Dragger>
  );
};

export default DragAndDrop;
